module.exports = __webpack_public_path__ + "img/houzz.c7a88a06.png";